export const NAME = "timetableAdmin";
export const SET_SIDEBAR_ACTIVE_TAB = "SET_SIDEBAR_ACTIVE_TAB" + " " + NAME;
export const SET_CREATED_ROUTINE_ID = "SET_CREATED_ROUTINE_ID" + " " + NAME;
export const NON_CYCLE = "non_cycle";
export const NON_APPLICABLE = "not_applicable";

export const UPDATE_ADD_PERIOD_BUTTON_DISABLED =
  "UPDATE_ADD_PERIOD_BUTTON_DISABLED" + " " + NAME;

export const UPDATE_ACTION_BUTTONS_DISABLED =
  "UPDATE_ACTION_BUTTONS_DISABLED" + " " + NAME;

export const UPDATE_EDIT_PERIOD_ID = "UPDATE_EDIT_PERIOD_ID" + " " + NAME;

export const UPDATE_DOWNLOAD_META_DATA =
  "UPDATE_DOWNLOAD_META_DATA" + " " + NAME;

export const MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
